<template>
  <CCol sm="12" class="mt-5 mb-4 p-0" :class="{ borderSection: !loading }">
    <div class="d-flex flex-column justify-content-center align-items-center p-5" :class="{ 'bg-gray-200': loading }">
      <CSpinner class="my-3" color="primary" />
      <div class="py-4 text-gray-600" v-if="loading">
        <slot name="contentLoading"></slot>
      </div>
      <div
        class="
          d-flex
          justify-content-center
          align-items-center
          flex-column
          py-4
          text-gray-600
        "
        v-else
      >
        <slot name="content"> </slot>
        <router-link v-if="linkTo" :to="linkTo" tag="span" class="text-uppercase p-3 mt-4 flex-inline btn btn-white">{{ textLinkTo }}</router-link>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="!loading"
        class="
          d-flex
          align-items-center
          text-center
          flex-column
          bg-gray-200
          py-5
        "
      >
        <div style="max-width: 850px; margin: auto">
          <slot name="insights"> </slot>
        </div>
      </div>
    </transition>
  </CCol>
</template>

<script>
import services from '@/services.js'

export default {
  name: 'HeroLoading',
  props: {
    linkTo: {
      type: Object,
    },
    textLinkTo: {
      type: String,
    },
    status: {
      type: Boolean,
    },
  },

  data() {
    return {
      loading: true,
      timeLoading: null,
      timeInsight: null,
      intervalTime: null,
    }
  },

  mounted() {
    this.countComponent(this.$configs.VUE_APP_TIME_LOADING, this.$configs.VUE_APP_TIME_INSIGHT)
  },

  destroyed() {
    this.clearTime()
  },

  beforeRouteLeave(to, from, next) {
    this.clearTime()
    next()
  },

  beforeDestroy() {
    this.clearTime()
  },

  methods: {
    countComponent(time, timeRedirect) {
      // tempo para mostrar insights
      this.timeLoading = setTimeout(() => {
        this.loading = false
      }, time)
    },
    clearTime() {
      clearTimeout(this.timeLoading)
      clearTimeout(this.timeInsight)
    },
  },
}
</script>

<style lang="scss" scoped>
.borderSection {
  border: 2px solid var(--gray-200);
}
</style>
